import { render, staticRenderFns } from "./CustomDialog.vue?vue&type=template&id=61cf0f91&scoped=true&"
import script from "./CustomDialog.vue?vue&type=script&lang=ts&"
export * from "./CustomDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61cf0f91",
  null
  
)

export default component.exports